import { GQL_INTROSPECTION_QUERIES } from './schemaTypes';

/**
 * Parse a sendRequest response body into `{ schema, error }`.
 */
export function parseIntrospectionResponse(result) {
  let parsed;
  try {
    parsed = typeof result?.data === 'string' ? JSON.parse(result.data) : result?.data;
  } catch {
    parsed = null;
  }
  if (parsed?.data?.__schema) {
    return { schema: parsed.data.__schema, error: null };
  }
  const message = parsed?.errors?.[0]?.message || 'Unexpected introspection response';
  const isDepthError = /depth limit|max depth|too deep/i.test(message);
  return { schema: null, error: message, isDepthError };
}

/** Try introspection queries in order until one succeeds. */
export async function introspectSchema(sendRequestFn, { url, headers, queries = GQL_INTROSPECTION_QUERIES }) {
  let lastError = 'Introspection failed';
  for (const query of queries) {
    const result = await sendRequestFn({
      method: 'POST',
      url,
      headers,
      body: JSON.stringify({ query }),
    });
    const { schema, error } = parseIntrospectionResponse(result);
    if (schema) return { schema, error: null };
    lastError = error || lastError;
  }
  return { schema: null, error: lastError };
}
